var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderbyBinaryGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6259 3C6.77242 3 6.90553 2.92422 6.96676 2.80595C7.03718 2.66992 6.98909 2.53063 6.88472 2.42284C6.13023 1.64773 5.37913 0.778236 4.44278 0.165242C4.31353 0.0806316 4.16559 0 3.99966 0C3.83372 0 3.68578 0.0806313 3.55654 0.165242C2.65059 0.758331 1.91922 1.59841 1.18745 2.348C1.06111 2.47778 0.940149 2.62745 1.03256 2.80595C1.09378 2.92422 1.22689 3 1.37341 3H6.6259Z",
    fill: "#9296AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6259 5C6.77242 5 6.90553 5.07578 6.96676 5.19405C7.03718 5.33008 6.98909 5.46937 6.88472 5.57716C6.13023 6.35227 5.37913 7.22176 4.44278 7.83476C4.31353 7.91937 4.16559 8 3.99966 8C3.83372 8 3.68578 7.91937 3.55654 7.83476C2.65059 7.24167 1.91922 6.40159 1.18745 5.652C1.06111 5.52222 0.940149 5.37255 1.03256 5.19405C1.09378 5.07578 1.22689 5 1.37341 5H6.6259Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderbyBinaryGray);
export default __webpack_public_path__ + "static/media/orderbyBinaryGray.ec5192a4dbc93bbb23a99d57cde32257.svg";
export { ForwardRef as ReactComponent };